// 登录只暂存站内目标地址，不挂载目标页或请求其个人数据。
const STORAGE_KEY = 'chatyy:login-return-route';
const MAX_AGE = 30 * 60 * 1000;
interface PendingRoute { target: string; background: string; createdAt: number }
let pendingMemory: PendingRoute | null = null;
let previousBackground = '';

export const localRoute = (value: unknown): string | null => {
  if (typeof value !== 'string' || !/^\/(?!\/)/.test(value) || /[\\\u0000-\u001f]/.test(value)) return null;
  const url = new URL(value, window.location.origin);
  return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : null;
};

export const routeWithoutEmbedding = (pathname: string, search = '', hash = '') => {
  const params = new URLSearchParams(search);
  params.delete('workspace');
  return `${pathname}${params.toString() ? `?${params}` : ''}${hash}`;
};

/** 返回已有的所属页面。会员页可展示自身静态布局，不跳转。 */
export const getLoginBackground = (pathname: string, search = '', protectedRoute = false): string | null => {
  const params = new URLSearchParams(search);
  if (pathname === '/vip-pay') return null;
  if (pathname === '/' || pathname === '/workspace-v2-preview') {
    const legacy = params.get('legacyview');
    if (legacy?.startsWith('custom-model-')) return '/?hometype=chat&featureCode=custom_model';
    if (legacy === 'collection') return '/?hometype=chat';
    if (legacy === 'distribution') return '/?hometype=chat&legacyview=distribution-home';
    if (params.has('workplaceview')) return '/?hometype=workworld';
    if (params.has('academictool')) return '/?hometype=academic&academicview=tools';
    if (params.has('chatid')) return '/?hometype=academic&academicview=chat';
    if (params.has('sessionid')) return params.get('hometype') === 'painting' ? '/?hometype=painting' : '/?hometype=chat';
    return null;
  }
  if (!protectedRoute) return null;
  if (pathname.startsWith('/custom-model-')) return '/?hometype=chat&featureCode=custom_model';
  if (pathname === '/distribution') return '/?hometype=chat&legacyview=distribution-home';
  if (pathname.startsWith('/netdisk')) return '/?hometype=academic&academicview=library';
  if (pathname.startsWith('/scholar/') || pathname.startsWith('/search') || pathname === '/chat-ai-search') return '/?hometype=academic';
  if (pathname.startsWith('/paper_') || pathname === '/full-text-translate') return '/?hometype=academic&academicview=tools';
  if (pathname.startsWith('/copywriting/') || ['/analysis', '/reading', '/translate', '/event_plan', '/work_summary', '/financial_report', '/ppt'].includes(pathname)) return '/?hometype=workworld';
  if (['/pictureDetail', '/dalle', '/nano-banana'].includes(pathname)) return '/?hometype=painting';
  return '/?hometype=chat';
};

export const rememberLoginBackground = (route: string) => {
  previousBackground = localRoute(route) || '';
};

export const clearLoginReturnRoute = () => {
  pendingMemory = null;
  try { sessionStorage.removeItem(STORAGE_KEY); } catch { /* 禁用存储时仍支持本次登录 */ }
};

export const readLoginReturnRoute = (): PendingRoute | null => {
  let value = pendingMemory;
  try { value = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null') || value; } catch { /* 使用内存 */ }
  if (!value || !localRoute(value.target) || !localRoute(value.background) || !Number.isFinite(value.createdAt) || Date.now() - value.createdAt > MAX_AGE) {
    clearLoginReturnRoute();
    return null;
  }
  return value;
};

export const prepareLoginReturnRoute = (target: string, fallback: string) => {
  const safeTarget = localRoute(target);
  const background = previousBackground && previousBackground !== safeTarget ? previousBackground : fallback;
  if (!safeTarget || !localRoute(background)) return fallback;
  pendingMemory = { target: safeTarget, background, createdAt: Date.now() };
  try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pendingMemory)); } catch { /* 使用内存 */ }
  return background;
};

export const consumeLoginReturnRoute = () => {
  const pending = readLoginReturnRoute();
  clearLoginReturnRoute();
  const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  return pending?.background === current ? pending.target : null;
};
